import { NavLink, Link } from "react-router-dom";

const Nav = () => {
  return (
    <nav className="navigation container">
      <Link className="link nav-brand" to="/">
        tushar's portfolio
      </Link>
      <ul className="list-non-bullet nav-pills">
        <li className="list-item-inline">
          <NavLink exact="true" to="/" className="link">
            home
          </NavLink>
        </li>
        <li className="list-item-inline">
          <NavLink to="/project" className="link">
            projects
          </NavLink>
        </li>
        <li className="list-item-inline">
          <NavLink to="/blog" className="link">
            blogs
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
